import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

let $root = document.getElementById('root');
ReactDOM.render(<App />, $root);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js